import { render, staticRenderFns } from "./AttachedApendix.vue?vue&type=template&id=bbf08632"
import script from "./AttachedApendix.vue?vue&type=script&lang=js"
export * from "./AttachedApendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports